//react npm components
import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types'
import axios from "axios";
//import "babel-polyfill";

//action 
import { resourceBundleAction } from "../middleware/resourceBundleAction";
import { fetchAction } from "../middleware/fetchAction"
import { getUrlMappingsAction } from '../middleware/getUrlMappingsAction';
import { getLoaderStatusAction } from '../middleware/getLoaderStatusAction';

//UI components
import Loader from '../components/Loader/Loader';
import MyComponent from '../components/MyComponent';
import Preview from './Preview';




export class MainLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            obj: this.props.fetch,
            isResourceBundleLoaded: this.props.resourceBundle ? true : false,
            methodInitiated: false,
            nonHeaderScreen: false,
            previousUrl: false,
            userLoggedIn: false,
            loading: false
        };
       
    }

    componentDidMount() {
        // this.props.getUrlMappingsAction("", `${this.props.preloadState.url}/get-url-mappings`);

        if (this.props.resourceBundle && this.props.resourceBundle.StorefrontUiLabels && !this.state.isResourceBundleLoaded) {
            this.setState({
                isResourceBundleLoaded: true,
                obj: this.props.fetch,
            })
            // Helper.setResourceBundle(this.props.resourceBundle)
            //this.render();
        }
    }

    async componentWillReceiveProps(nextProps) {
         if (nextProps.resourceBundle && nextProps.resourceBundle.StorefrontUiLabels && !this.state.isResourceBundleLoaded) {
            this.setState({
                isResourceBundleLoaded: true,
                obj: nextProps.fetch,
                methodInitiated: false
            })
            // Helper.setResourceBundle(nextProps.resourceBundle)
            //this.render();
        }
        //var postURL = actionUrl(window.location.pathname+window.location.search); 
        //var postURL= `${window.location.protocol}//${window.location.hostname}${window.location.pathname}${window.location.search}?format=json`;     
        var url = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}${window.location.search}`;
        var format = (url.includes('?') ? `&format=json&ajax=true` : '?format=json&ajax=true');
        var postURL = `${url}${format}`
        var ajaxResponse;
        if (postURL != this.state.previousUrl && !this.state.methodInitiated) {
            this.props.getLoaderStatusAction(true)
            this.setState({
                methodInitiated: true,
                loading: true
            })
            var obj = await axios.get(postURL, {
                withCredentials: true
            })
                .then(function (response) {
                    // handle success
                    ajaxResponse = response.data;
                })
                .catch(function (err) {
                   switch (err.response.status) {
                        case 404:
                            ajaxResponse = err.response.data;
                            break;
                        case 403:
                            ajaxResponse = err.response.data;
                            break;
                        case 500:
                            ajaxResponse = err.response.data;
                            break;
                        default:
                            break;
                    }
                })
            this.setState({
                obj: ajaxResponse,
                previousUrl: postURL,
                methodInitiated: false
            });
            //this.render();   

            const titleElement = document.querySelector('title')
            if (ajaxResponse && ajaxResponse.pageTitle) {
                titleElement.innerHTML = ajaxResponse.pageTitle
            } else {
                titleElement.innerHTML = "Carolina Biological Supply"
            }
            const descriptionElement = document.querySelector("meta[name='description']");
            const keywordsElement = document.querySelector("meta[name='keywords']");

            if (ajaxResponse && ajaxResponse.hasOwnProperty('metaData') && ajaxResponse['metaData'].metaDescription) {
                descriptionElement.setAttribute('content', ajaxResponse['metaData'].metaDescription)
            }
            if (ajaxResponse && ajaxResponse.hasOwnProperty('metaData') && ajaxResponse['metaData'].metaKeywords) {
                keywordsElement.setAttribute('content', ajaxResponse['metaData'].metaKeywords)
            }
            //document.querySelector('title').innerHTML = 'Test ColumbiaPipe'
            this.props.getLoaderStatusAction(false)
            this.setState({
                loading: false
            })
        }
    }


    isNotEmptyObject(obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                return true;
            }
        }
        return false;
    }


    render() {
        const state = this.state.obj;
        //const  headerObj = this.state.headerObj;
        //this following line is to restrict multiple rendering of existing component
        if (this.isNotEmptyObject(state) && this.state.isResourceBundleLoaded && !this.state.loading) {
            //if (this.isNotEmptyObject(state) && this.state.isResourceBundleLoaded) {
            return (this.loadComponent(state))
        } else {
            return (
                <Loader></Loader>
            )
        }

    }

    loadComponent(state) {
        var PageType = state['@type'];
        return (
           
            <div>
                 <Preview/>
                <MyComponent type={PageType} state={state} />
                <style>
                    {state['customCss']}
                </style>
            </div>
        )
    }
}


const mapStateToProp = state => ({
    resourceBundle: state.resourceBundle.response,
    fetch: state.fetch.response,
    getUrlMappings: state.getUrlMappings.response,
    getLoaderStatus: state.getLoaderStatus.response,

});

MainLayout.propTypes = {
    resourceBundleAction: PropTypes.func.isRequired,
    fetchAction: PropTypes.func.isRequired,
    getUrlMappingsAction: PropTypes.func.isRequired,
    getLoaderStatusAction: PropTypes.func.isRequired

};

export default connect(mapStateToProp, { fetchAction, resourceBundleAction, getUrlMappingsAction, getLoaderStatusAction })(MainLayout);
